var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.category.files.length)?_c('FilesField',{attrs:{"category":_vm.category,"content-type":"image"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }